import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './TabsNav.module.scss';

// import ArrowDown from 'common/images/arrow_down_orange.svg'; // temporary we don't need to use mobileRender

export default class TabsNav extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    onChangeSlide: PropTypes.func.isRequired,
    activeSlideIndex: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      activeSlideIndex: props.activeSlideIndex
    };
  }

  static getDerivedStateFromComponent(props, state) {
    if (state.activeSlideIndex !== props.activeSlideIndex) {
      return { activeSlideIndex: props.activeSlideIndex };
    }
    return null;
  }

  renderDesktop() {
    const navItems = this.props.items.map((panel, index) => {
      const name = panel.props.name;
      const isActive = index === this.state.activeSlideIndex;

      return (
        <span
          key={index}
          className={`${styles.Link} ${isActive ? styles.Active : ''}`}
          onClick={() => this.onChangeSlide(index)}
        >
          {name}
        </span>
      );
    });

    return <div className={styles.TabsNav}>{navItems}</div>;
  }

  // renderMobile() {
  //   const navItems = this.props.items.map((panel, index) => {
  //     const name = panel.props.name;

  //     return (
  //       <option key={index} value={index}>
  //         {name}
  //       </option>
  //     );
  //   });

  //   return (
  //     <div className={styles.SelectWrapper}>
  //       <select
  //         className={styles.SelectLink}
  //         onChange={e => this.onChangeSlide(parseInt(e.target.value))}
  //         value={this.state.activeSlideIndex}
  //       >
  //         {navItems}
  //       </select>
  //       <img className={styles.SelectArrow} src={ArrowDown} alt="Arrow down" />
  //     </div>
  //   );
  // }

  render() {
    // return this.props.isMobile ? this.renderMobile() : this.renderDesktop(); // temporary we don't need to use mobileRender
    return this.renderDesktop();
  }

  setActive(index) {
    this.setState({
      activeSlideIndex: index
    });
  }

  onChangeSlide(index) {
    this.props.onChangeSlide(index);
    this.setActive(index);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Tabs/TabsNav/TabsNav.js